module.exports = __webpack_public_path__ + "static/media/unstakeLightActive.1fa7f070.svg";